var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 10,
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43406 4.99981C5.43427 4.73476 5.32924 4.48047 5.14206 4.29282L1.02406 0.175815C0.968488 0.119941 0.902421 0.0756004 0.829656 0.0453441C0.756891 0.0150878 0.678864 -0.000488281 0.600059 -0.000488281C0.521254 -0.000488281 0.443227 0.0150878 0.370462 0.0453441C0.297698 0.0756004 0.231631 0.119941 0.176059 0.175815C0.120184 0.231387 0.0758443 0.297453 0.045588 0.370218C0.0153317 0.442983 -0.000244141 0.521011 -0.000244141 0.599815C-0.000244141 0.67862 0.0153317 0.756647 0.045588 0.829412C0.0758443 0.902177 0.120184 0.968244 0.176059 1.02382L4.15106 4.99981L0.176059 8.97581C0.120184 9.03139 0.0758443 9.09745 0.045588 9.17022C0.0153317 9.24298 -0.000244141 9.32101 -0.000244141 9.39981C-0.000244141 9.47862 0.0153317 9.55665 0.045588 9.62941C0.0758443 9.70218 0.120184 9.76824 0.176059 9.82382C0.231631 9.87969 0.297698 9.92403 0.370462 9.95429C0.443227 9.98454 0.521254 10.0001 0.600059 10.0001C0.678864 10.0001 0.756891 9.98454 0.829656 9.95429C0.902421 9.92403 0.968488 9.87969 1.02406 9.82382L5.14206 5.70681C5.32924 5.51916 5.43427 5.26487 5.43406 4.99981",
    fill: "#868B92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/angleRight.e11d0267ec82c6f08c4391c7af48f1ee.svg";
export { ForwardRef as ReactComponent };